import {
  i18n,
} from '@i18n';
import type {
  IQTooltipOptions,
} from '@qmulus/ui';

import {
  EAppId,
} from '@/types/app-type.ts';

const I18N_PREFIX = 'components/modal-release-highlights-host/modal-release-highlights-host';

/**
 * Joins the labels the user clicks through, so that the hint follows renamed menu entries. Italic like
 * the paths in the release highlights.
 */
function formatMenuLocation(labelList: string[]): string {
  return `<em>${labelList.join(' > ')}</em>`;
}

/** Tooltip of the opt-out checkbox of the release highlights modal. */
export function buildReleaseHighlightsOptOutHint(): IQTooltipOptions {
  const settingsLabel = i18n.global.t(`api.AppId.${EAppId.TENANT_SETTINGS}`);
  const releaseHighlightsLocation = formatMenuLocation([
    settingsLabel,
    i18n.global.t('page.releaseHighlights.title'),
  ]);
  const appearanceLocation = formatMenuLocation([
    settingsLabel,
    i18n.global.t('page/general-settings/general-settings.userSettings'),
    i18n.global.t('common.appearance'),
  ]);
  return {
    // The tooltip keeps line breaks (`white-space: pre-line`), so the only one is the break after the title.
    value: [
      `<strong>${i18n.global.t(`${I18N_PREFIX}.optOutHint.title`)}</strong>\n`,
      i18n.global.t(`${I18N_PREFIX}.optOutHint.availability`),
      '<ul>',
      `<li>${i18n.global.t(`${I18N_PREFIX}.optOutHint.versionNumber`)}</li>`,
      `<li>${releaseHighlightsLocation}</li>`,
      '</ul>',
      i18n.global.t(`${I18N_PREFIX}.optOutHint.showAgain`, {
        location: appearanceLocation,
      }),
    ].join(''),
    escape: false,
    position: 'top',
    maxWidth: '24rem',
  };
}
